import { takeLatest, takeEvery } from 'redux-saga'
import { put, select, call } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import { ltiSync } from '../../sync'
import callAny from './helpers/call_any'
import ltiDataSelector from 'redux/selectors/lti/lti_data_selector'
import myLibraryActions from 'redux/actions/my_library_actions'


function *associateUser() {
	try {
		const {ltiUid, ltiToken} = yield select(ltiDataSelector)
		if (ltiUid !== '' && ltiToken !== '') {
			yield callAny(ltiSync.associateUser, ltiUid, ltiToken)
		}
	} catch (error) {
		//todo: handle lti association error
	}
}

function *handleCanvasSaved(action) {
	try {
		if (!action.teams && action.payload.forwardUrl && action.payload.postParams) {
			yield call(ltiSync.sendLtiForm, action.payload.forwardUrl, action.payload.postParams)
		} else {
			yield put(myLibraryActions.myLibrarySessionLtiSavedSuccess(action.payload, action.presentationUid, action.teams))
		}
	} catch (error) {
		yield put(myLibraryActions.myLibrarySessionLtiSavedError())
	}
}


export default [
	takeLatest(actionTypes.MY_LIBRARY_INITIALIZE, associateUser),
	takeEvery(actionTypes.MY_LIBRARY_SESSION_LTI_CANVAS_SAVED, handleCanvasSaved),
]

export {
	associateUser,
	handleCanvasSaved,
}
